import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';
import axios from '../utils/APIUtils';
import { DATAGPT_API_PATHS } from '../constants/constants';
 

export const initialState = {
  dataGpt: {
    status: 'idle'
  }
}; 

export const getDataGPTResponse = createAsyncThunk(
  'dataGPT/getDataGPTResponse',
  async () => {
    const response = await axios.post(DATAGPT_API_PATHS.responseDetails);
    return response.data;
  }
);

export const getAllQueryHistoryDetails = createAsyncThunk(
    'dataGPT/getAllQueryHistoryDetails',
    async () => {
        const response = await axios.get(DATAGPT_API_PATHS.getHistoryDetails);
        return response.data
    }
)

export const getDSModelResponse = createAsyncThunk(
  'dataGPT/getDSModelResponse',
    async (args: any) => {
    const response = await axios.post(
      DATAGPT_API_PATHS.getDSModelResponse,
      args
    );
    return response.data;
  }
);
 

export const dataGPTSlice = createSlice({
  name: 'dataGPT',
  initialState,
  reducers: {
  }, 

  extraReducers: (builder) => {
    builder.addCase(getDataGPTResponse.pending, (state) => {
      state.dataGpt.status = 'loading';
    });
    builder.addCase(getDataGPTResponse.fulfilled, (state) => {
      state.dataGpt.status = 'finished';
    });
    builder.addCase(getDataGPTResponse.rejected, (state) => {
      state.dataGpt.status = 'error';
    });
    builder.addCase(getAllQueryHistoryDetails.pending, (state) => {
        state.dataGpt.status = 'loading';
    });
    builder.addCase(getAllQueryHistoryDetails.fulfilled, (state) => {
        state.dataGpt.status = 'finished';
    });
    builder.addCase(getAllQueryHistoryDetails.rejected, (state) => {
        state.dataGpt.status = 'error';
    });
  },
});

export default dataGPTSlice.reducer;